import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { GitQuery } from '@y42/git';
import { isNotNullish } from '@y42/util/nullish';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'y42-data-test-commit-button[filePath]',
  templateUrl: './data-test-commit-button.component.html',
  styleUrls: ['./data-test-commit-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTestCommitButtonComponent {
  constructor(private readonly gitQuery: GitQuery) {}

  @Input() class = '';

  @Input()
  @InputObservable()
  filePath: string | undefined = undefined;
  filePath$!: Observable<string | undefined>;

  @Output() commit = new EventEmitter<void>();

  private readonly testsPendingCommits$ = combineLatest([this.gitQuery.modifiedFilesList$, this.filePath$]).pipe(
    map(
      ([changedFiles, filePath]) =>
        isNotNullish(filePath) &&
        changedFiles.some((changedFile) => changedFile.startsWith(filePath) && changedFile.endsWith('tests.json')),
    ),
  );

  readonly state = connectState(this, {
    isDisabled: this.testsPendingCommits$.pipe(map((testPending) => !testPending)),
  });

  commitClick() {
    this.commit.emit();
  }
}
